module.exports = __webpack_public_path__ + "carousel_04_img_06.png?1150187fe514bcc10ab16aaed17f7603";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel_04_img_06.png
// module id = 161
// module chunks = 0